export default __webpack_public_path__ + "locales/el-GR/JavascriptSdk.json?hash=d7f42164a20318fbb2364546fedd5202";